import React, { useState } from 'react'

export const Checkmark = ({ width = 17, height = 13, color = '#ffffff' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6202 0.207435C16.0584 0.543649 16.141 1.1714 15.8048 1.60955L7.3686 12.6036C6.99385 13.092 6.27313 13.1344 5.8437 12.6933L0.847993 7.56279C0.462704 7.1671 0.471136 6.53399 0.866826 6.1487C1.26252 5.76341 1.89562 5.77184 2.28091 6.16753L6.47843 10.4784L14.2181 0.392015C14.5543 -0.0461394 15.1821 -0.128778 15.6202 0.207435Z"
        fill={color}
      />
    </svg>
  )
}
